import { useState, useEffect, useRef } from 'react';
import { useViewport } from './index';

const THRESHOLD = 200;

const useScrollDirection = () => {
    const viewport = useViewport();
    const isMobile = viewport <= 700;
    const [scrollDirection, setScrollDirection] = useState(isMobile ? 'down' : 'up');

    const blocking = useRef(false);
    const prevScrollY = useRef(0);

    useEffect(() => {
        prevScrollY.current = window.pageYOffset;

        const updateScrollDirection = () => {
            const scrollY = window.pageYOffset;

            if (Math.abs(scrollY - prevScrollY.current) >= THRESHOLD) {
                const newScrollDirection = scrollY > prevScrollY.current ? 'down' : 'up';

                setScrollDirection(newScrollDirection);

                prevScrollY.current = scrollY > 0 ? scrollY : 0;
            }

            blocking.current = false;
        };

        const onScroll = () => {
            if (!blocking.current) {
                blocking.current = true;
                window.requestAnimationFrame(updateScrollDirection);
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, [scrollDirection]);

    return scrollDirection;
};

export default useScrollDirection;
